import NewsroomAssets, { NewsroomAssetsProps } from "./NewsroomAssets";

export { NewsroomAssets, NewsroomAssetsProps };

export default NewsroomAssets;
